import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import SupportWidget from "@/components/support/SupportWidget";
import { api } from "@/lib/api";
import { shopApi } from "@/lib/shopApi";
import { getTheme } from "@/lib/templates";

// Routes connues de la PLATEFORME (site principal) -> widget plateforme.
const PLATFORM_ROUTES = new Set([
  "", "auth", "devenir-revendeur", "terms", "privacy",
  "reseller", "dashboard", "profile",
]);

// Domaine principal (numwave.net). Tout autre hôte = boutique d'un revendeur.
const MAIN_DOMAIN = (process.env.REACT_APP_MAIN_DOMAIN || "").toLowerCase().trim();

function isShopHost() {
  if (!MAIN_DOMAIN || typeof window === "undefined") return false;
  const h = (window.location.hostname || "").toLowerCase();
  return !(h === "localhost" || h === "127.0.0.1" || h === MAIN_DOMAIN || h === `www.${MAIN_DOMAIN}`);
}

// Boutique servie sur son propre (sous-)domaine : on résout le slug via le host,
// puis on affiche le widget de LA boutique (couleur = template du revendeur).
function ShopHostSupport() {
  const [slug, setSlug] = useState(undefined);
  useEffect(() => {
    let alive = true;
    api.get("/public/site-by-host", { params: { host: window.location.hostname } })
      .then((r) => { if (alive) setSlug(r.data?.slug || null); })
      .catch(() => { if (alive) setSlug(null); });
    return () => { alive = false; };
  }, []);
  if (!slug) return null;
  return <ShopSupport slug={slug} />;
}

// Widget d'une boutique : récupère le template pour adapter la couleur de l'icône.
function ShopSupport({ slug }) {
  const [accent, setAccent] = useState(null);
  const [ok, setOk] = useState(true);
  useEffect(() => {
    let alive = true;
    shopApi.get(`/shop/${slug}`)
      .then((r) => { if (alive) setAccent(getTheme(r.data?.template).accent); })
      .catch(() => { if (alive) setOk(false); });
    return () => { alive = false; };
  }, [slug]);
  if (!ok) return null;            // ce n'est pas une boutique valide
  if (!accent) return null;        // on attend la couleur du template
  return <SupportWidget client={shopApi} spaceSlug={slug} accent={accent} title="Support" />;
}

// Affiche le bon widget selon la page, sur TOUTES les pages :
//  - /r/<slug>... ou /<slug> (boutique) -> widget boutique (couleur = template)
//  - pages plateforme -> widget plateforme (couleur Numwave)
//  - /admin -> aucun widget (le super-admin gère le support, il ne le contacte pas)
export default function GlobalSupport() {
  const { pathname } = useLocation();
  const segs = pathname.split("/").filter(Boolean);
  const first = segs[0] || "";

  if (first === "admin") return null;

  // Sur un sous-domaine boutique (slug.xnums.com) -> widget de LA boutique
  // (couleur du template), même à la racine "/". Prioritaire sur le chemin.
  if (isShopHost()) return <ShopHostSupport />;

  // Boutique explicite : /r/<slug>
  if (first === "r" && segs[1]) return <ShopSupport slug={segs[1]} />;

  // Route plateforme connue -> widget plateforme.
  if (PLATFORM_ROUTES.has(first)) {
    return <SupportWidget client={api} spaceSlug="" accent="#4fa827" title="Support Numwave" />;
  }

  // Sinon, segment unique = slug de boutique en wildcard (/<slug>) -> widget boutique.
  if (first && segs.length === 1) return <ShopSupport slug={first} />;

  return null;
}
